import { create } from 'zustand';
import type { DiscoverResponse } from '@pleco/shared';
import { api } from './api.js';

/** Popular + live tokens, fetched once and refreshed every minute while anything uses them. */
interface DiscoverState {
  data?: DiscoverResponse;
  users: number;
  timer?: ReturnType<typeof setInterval>;
  load: () => Promise<void>;
  subscribe: () => () => void;
}

export const useDiscover = create<DiscoverState>((set, get) => ({
  users: 0,
  async load() {
    try {
      set({ data: await api.discover() });
    } catch {
      /* keep the last list */
    }
  },
  subscribe() {
    const s = get();
    if (s.users === 0) {
      void s.load();
      set({ timer: setInterval(() => void get().load(), 60_000) });
    }
    set({ users: get().users + 1 });
    return () => {
      const n = get().users - 1;
      set({ users: n });
      if (n === 0) {
        clearInterval(get().timer);
        set({ timer: undefined });
      }
    };
  },
}));
